import { trackById, trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from 'src/app/services/toast.service';
import { Enum } from 'src/app/models/enum.model';
import { CustomObjectService } from 'src/app/services/customObject.service';
import { CustomObject } from 'src/app/models/customObject.model';
import { IconList } from 'src/app/shared/iconList';

@Component({
  standalone: false,
    selector: 'app-create-custom-object-dialog',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: 'createCustomObjectDialog.component.html',
})
export class CreateCustomObjectDialogComponent implements OnInit, OnDestroy {

    isFormLoading = false;
    isLoading = false;
    customObjectTypes: Enum[];
    isTypePreSet: boolean;
    icons: string[] = [];

    constructor(public dialogRef: MatDialogRef<CreateCustomObjectDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public customObject: CustomObject,
        private customObjectService: CustomObjectService,
        private toastService: ToastService
    ) {
        this.icons.push(...IconList.icons.map(x => x.value));
    }

    ngOnInit() {
        this.isFormLoading = true;
        this.customObjectService.getCustomObjectTypes()
            .subscribe(
                result => {
                    this.customObjectTypes = result;
                    this.isTypePreSet = this.customObject && this.customObject.type !== undefined;
                    this.isFormLoading = false;
                },
                error => {
                    this.toastService.showError(error);
                    this.isFormLoading = false;
                }
            );
    }

    create() {
        this.isLoading = true;
        this.customObjectService.create(this.customObject)
            .subscribe(coId => {
                this.isLoading = false;
                this.toastService.showSuccess(`${this.customObject.typeName} created successfully.`, true);
                this.dialogRef.close(coId);
            }, error => {
                this.isLoading = false;
                this.toastService.showError(error);
            });
    }

    public trackById = trackById;
    public trackByIndex = trackByIndex;

    ngOnDestroy() {
    }
}
